// extracted by mini-css-extract-plugin
export default {"PasswordResetEmail":"yp_a bhf_qr bhf_a bhf_w bhf_ea bhf_tg","PasswordResetEmail__title":"yp_b bhf_vn bhf_re bhf_uy","PasswordResetEmail__subtitle":"yp_c bhf_uy"};